module.exports = __webpack_public_path__ + "dash_20_app_assets/img/foursquarehow.ba04556d.png";